import { Link } from "react-router";
import Heading from "@core/components/title/Heading";
import { Button } from "@core/components/ui";
import { ChevronRight } from "lucide-react";

export default function AccountRegister() {
  return (
    <div className="flex h-full flex-col items-center justify-center text-center max-lg:pb-[30px]">
      <Heading level={1} className="text-lg font-normal">
        <span className="font-bold">PC방 사장님,</span> 안녕하세요! <br />
        PLAYNC 계정으로 모든 사업장을
        <br /> 한 번에 관리하세요.
      </Heading>
      <Button variant="borderPoint200" size="large" className="mt-[60px]" asChild>
        <Link to="/account/register">
          가입하기
          <ChevronRight className="ml-[8px] size-4" />
        </Link>
      </Button>
    </div>
  );
}
